import { TuiIcon } from '@taiga-ui/core';
import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { WorkflowFormFieldOutputHintPopulated } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-output-hint-field',
  imports: [TuiTooltip, TuiIcon],
  templateUrl: './output-hint-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputHintFieldComponent {
  field = input.required<WorkflowFormFieldOutputHintPopulated>();

  /**
   * Helper to get files array with proper type
   */
  protected getFiles(): Array<{ src: string; title?: string }> {
    return this.field().files || [];
  }
}
